import { BrgButton, Colors, FInter, FlexBox, MEDIA } from "@brg/ui";
import { SendProjectButton } from "_competition/components/SendProjectButton";
import { LayoutConst } from "core";
import styled from "styled-components";

export const BackLink = styled(FInter.SectionTitleDiv)`
  cursor: pointer;
  transition: all 0.2s;
  color: ${({ theme }) => theme.competition.mainText};

  &:hover {
    opacity: 0.71;
  }
`;

export const ModalWrapper = styled(FlexBox)`
    position: relative;
.close-modal-icon {
    position: absolute;
    top: 80px;
    right: 80px;
}

@media ${MEDIA.LAPTOP} {
    .close-modal-icon {
      width: 56px;
      height: 56px;
      top: 32px;
      right: 32px;
    }
  }
`;

export const SendButton = styled(BrgButton)`
    color: ${({ theme }) => theme.sendProjectsModal.buttons.send.importantColor};

    width: ${LayoutConst.projectCard.l.w}px;
    max-width: ${LayoutConst.projectCard.l.w}px;
    min-width: ${LayoutConst.projectCard.l.w}px;

    @media ${MEDIA.LAPTOP} {
        width: ${LayoutConst.projectCard.m.w}px;
        max-width: ${LayoutConst.projectCard.m.w}px;
        min-width: ${LayoutConst.projectCard.m.w}px;
    }

    @media ${MEDIA.TABLET} {
        width: calc(50vw - 16px - 8px);
        max-width: calc(50vw - 16px - 8px);
        min-width: calc(50vw - 16px - 8px);
    }

    @media ${MEDIA.MOBILE} {
        min-width: calc((50vw - 15px)* 1.407);
        max-width: 100%;
        width: auto;
        margin-left: 0 !important;
    }
`;

export const Label = styled.div`
    font-size: 30px;
    line-height: 40px;
    font-family: 'Inter';
    font-weight: 600;
    width: 100%;
    color: ${({ theme }) => theme.tags.educational.backgroundColor};
    margin-bottom: 16px;

    @media ${MEDIA.TABLET} {
        font-size: 22px;
        line-height: 28px;
    }
`;

export const ActionsWrapper = styled(FlexBox)<{ offsetTopMobile?: number }>`
    flex-flow: column;
    margin: 88px auto 0 auto;
    width: 100%;

    @media ${MEDIA.TABLET} {
        width: calc(100% - 32px);
        margin: ${({ offsetTopMobile }) => !!offsetTopMobile ? `${offsetTopMobile}px auto 0 auto;` : '0px auto 0 auto;'}
    }

    @media ${MEDIA.MOBILE} {
        width: calc(100% - 20px);
    }
`;

export const ProjectsCount = styled(FInter.Text)`
    color: ${Colors.galBlack100};
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
`;

export const ActionsTitle = styled(FlexBox)`
    width: 100%;
    margin-bottom: 40px;
    place-items: flex-start;
    row-gap: 24px;
`;

export const ActionsColumnBlock = styled(FlexBox)`
    flex-flow: column;
    width: 100%;
    justify-content: center;
    place-items: center;
`;

export const ButtonWrapper = styled(FlexBox)`
    @media ${MEDIA.MOBILE} {
        margin-top: 24px !important;
    }

    ${SendButton} {
        :not(first-child) {
            margin-top: 8px !important;
        }
    }
`;

import { BrgButton, Colors, FInter, FlexBox, MEDIA } from "@brg/ui";
import { SendProjectButton } from "_competition/components/SendProjectButton";
import { LayoutConst } from "core";
import styled from "styled-components";

export const BackLink = styled(FInter.SectionTitleDiv)`
  cursor: pointer;
  transition: all 0.2s;
  color: ${({ theme }) => theme.competition.mainText};

  &:hover {
    opacity: 0.71;
  }
`;

export const ModalWrapper = styled(FlexBox)`
    position: relative;
.close-modal-icon {
    position: absolute;
    top: 80px;
    right: 80px;
}

@media ${MEDIA.LAPTOP} {
    .close-modal-icon {
      width: 56px;
      height: 56px;
      top: 32px;
      right: 32px;
    }
  }
`;

export const SendButton = styled(BrgButton)`
    color: ${({ theme }) => theme.sendProjectsModal.buttons.send.importantColor};

    width: ${LayoutConst.projectCard.l.w}px;
    max-width: ${LayoutConst.projectCard.l.w}px;
    min-width: ${LayoutConst.projectCard.l.w}px;

    @media ${MEDIA.LAPTOP} {
        width: ${LayoutConst.projectCard.m.w}px;
        max-width: ${LayoutConst.projectCard.m.w}px;
        min-width: ${LayoutConst.projectCard.m.w}px;
    }

    @media ${MEDIA.TABLET} {
        width: calc(50vw - 16px - 8px);
        max-width: calc(50vw - 16px - 8px);
        min-width: calc(50vw - 16px - 8px);
    }

    @media ${MEDIA.MOBILE} {
        min-width: calc((50vw - 15px)* 1.407);
        max-width: 100%;
        width: auto;
        margin-left: 0 !important;
    }
`;

export const Label = styled.div`
    font-size: 30px;
    line-height: 40px;
    font-family: 'Inter';
    font-weight: 600;
    width: 100%;
    color: ${({ theme }) => theme.tags.educational.backgroundColor};
    margin-bottom: 16px;

    @media ${MEDIA.TABLET} {
        font-size: 22px;
        line-height: 28px;
    }
`;

export const ActionsWrapper = styled(FlexBox)<{ offsetTopMobile?: number }>`
    flex-flow: column;
    margin: 88px auto 0 auto;
    width: 100%;

    @media ${MEDIA.TABLET} {
        width: calc(100% - 32px);
        margin: ${({ offsetTopMobile }) => !!offsetTopMobile ? `${offsetTopMobile}px auto 0 auto;` : '0px auto 0 auto;'}
    }

    @media ${MEDIA.MOBILE} {
        width: calc(100% - 20px);
    }
`;

export const ProjectsCount = styled(FInter.Text)`
    color: ${Colors.galBlack100};
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
`;

export const ActionsTitle = styled(FlexBox)`
    width: 100%;
    margin-bottom: 40px;
    place-items: flex-start;
    row-gap: 24px;
`;

export const ActionsColumnBlock = styled(FlexBox)`
    flex-flow: column;
    width: 100%;
    justify-content: center;
    place-items: center;
`;

export const ButtonWrapper = styled(FlexBox)`
    @media ${MEDIA.MOBILE} {
        margin-top: 24px !important;
    }

    ${SendButton} {
        :not(first-child) {
            margin-top: 8px !important;
        }
    }
`;

